'use client'

import Link from 'next/link'
import { ADJUSTED_MARKET_CAP_DOCS_PATH } from '@domain/funds/utils/adjustedMarketCap'

/** Tooltip body for Current Valuation on SpaceX / xAI (merger dilution) funds. */
export function AdjustedMarketCapTooltipContent() {
  return (
    <span className="inline">
      Adjusted Live Market Cap.{' '}
      <Link
        href={ADJUSTED_MARKET_CAP_DOCS_PATH}
        className="font-semibold underline underline-offset-2 hover:opacity-80"
        onClick={(e) => e.stopPropagation()}
      >
        Learn More
      </Link>
    </span>
  )
}
